export enum EventEmitterName {
	COMPANY_CHANGE = 'COMPANY_CHANGE',
	LOGOUT = 'LOGOUT',
	OPEN_NOTIFICATION = 'OPEN_NOTIFICATION',
	LOAD_NOTIFICATION = 'LOAD_NOTIFICATION',
	LOGIN = 'LOGIN',
}

export type EventEmitterListener = <T>(data?: T) => void

export type EventEmitterListenersList = {
	[key in EventEmitterName]?: EventEmitterListener[]
}